var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11313",
    "data-name": "Path 11313",
    d: "M-188.75-573a1.252,1.252,0,0,1-1.25-1.25v-.417a7.45,7.45,0,0,1,2.2-5.3,7.45,7.45,0,0,1,5.3-2.2,7.45,7.45,0,0,1,5.3,2.2,7.45,7.45,0,0,1,2.2,5.3v.417a1.252,1.252,0,0,1-1.25,1.25Zm0-1.667v.069a.347.347,0,0,0,.347.347H-176.6a.348.348,0,0,0,.347-.347v-.069a6.257,6.257,0,0,0-6.25-6.25A6.257,6.257,0,0,0-188.75-574.667Zm3.009-9.676a4.553,4.553,0,0,1-1.342-3.241v-.834a4.554,4.554,0,0,1,1.342-3.241A4.554,4.554,0,0,1-182.5-593a4.553,4.553,0,0,1,3.241,1.342,4.554,4.554,0,0,1,1.342,3.241v.834a4.553,4.553,0,0,1-1.342,3.241A4.553,4.553,0,0,1-182.5-583,4.553,4.553,0,0,1-185.741-584.343Zm-.092-4.074v.834a3.337,3.337,0,0,0,3.333,3.333,3.337,3.337,0,0,0,3.333-3.333v-.834a3.337,3.337,0,0,0-3.333-3.333A3.337,3.337,0,0,0-185.833-588.417Z",
    transform: "translate(190 593)",
    fill: "#555b70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/iconUser.65e8db9a008c66cb8e5cffcc11b19e54.svg";
export { ForwardRef as ReactComponent };